import {
    takeLatest, call, put, select
} from 'redux-saga/effects';

import {
    REQUEST_ME,
    RECHECK_SESSION,
    setIdentity,
    setUnauthenticated,
    meFetchFailed,
    sessionExpired
} from './authModule';
import { getIsAuthenticated } from './authSelectors';
import { fetchIdentity } from './authApi';
import { logError } from '../utils/errorUtils';


export function* requestMeSaga() {
    try {
        const { authenticated, identity, sid } = yield call(fetchIdentity);
        if (authenticated) {
            yield put(setIdentity(identity, sid));
        } else {
            yield put(setUnauthenticated());
        }
    } catch (error) {
        logError('Error while fetching auth identity', { error });
        yield put(meFetchFailed());
    }
}






export function* recheckSessionSaga() {
    const isAuthenticated = yield select(getIsAuthenticated);
    if (!isAuthenticated) {
        return;
    }
    try {
        const { authenticated, identity, sid } = yield call(fetchIdentity);
        if (authenticated) {
            yield put(setIdentity(identity, sid));
        } else {
            yield put(sessionExpired());
        }
    } catch (error) {
        logError('Error while re-checking auth identity', { error });
    }
}

export function* authWatcher() {
    yield takeLatest(REQUEST_ME, requestMeSaga);
    yield takeLatest(RECHECK_SESSION, recheckSessionSaga);
}
